import { useEffect, useState } from 'react'

import { CarometroAluno } from '@core/types/services'

import { formatAlunoPhone } from '../../utils'
import * as S from './styles'

type Props = {
  aluno: CarometroAluno
  photoSrc?: string | null
  displayName: string
  onClick: () => void
}

const AlunoCard: React.FC<Props> = ({
  aluno,
  photoSrc,
  displayName,
  onClick
}) => {
  const [hasPhotoError, setHasPhotoError] = useState(false)

  useEffect(() => {
    setHasPhotoError(false)
  }, [photoSrc])

  return (
    <S.CardButton
      type="button"
      onClick={onClick}
      aria-label={`Abrir detalhes de ${displayName}`}
      title={`Abrir detalhes de ${displayName}`}
    >
      <S.PhotoWrapper>
        {photoSrc && !hasPhotoError ? (
          <S.Photo
            src={photoSrc}
            alt={`Foto do aluno ${displayName}`}
            onError={() => setHasPhotoError(true)}
          />
        ) : (
          <S.PhotoFallback aria-hidden="true" />
        )}
      </S.PhotoWrapper>

      <S.Content>
        <S.Name>{displayName}</S.Name>
        <S.Phone>{formatAlunoPhone(aluno.telefone)}</S.Phone>
      </S.Content>

      <S.ViewDetails>Ver detalhes</S.ViewDetails>
    </S.CardButton>
  )
}

export default AlunoCard
